export const SunShine = () => {
  return (
    <svg
      className="sunshine"
      fill="currentColor"
      height={'100%'}
      viewBox="0 0 512 512"
    >
      <path
        className="sun-full"
        d="M256,144c-61.8,0-112,50.2-112,112s50.2,112,112,112s112-50.2,112-112S317.8,144,256,144z M256,336
            c-44.2,0-80-35.8-80-80s35.8-80,80-80s80,35.8,80,80S300.2,336,256,336z"
      />
      <path
        className="sun-ray-eight"
        d="M131.6,357.8l-22.6,22.6c-6.2,6.2-6.2,16.4,0,22.6s16.4,6.2,22.6,0l22.6-22.6c6.2-6.3,6.2-16.4,0-22.6
            C147.9,351.6,137.8,351.6,131.6,357.8z"
      />
      <path
        className="sun-ray-seven"
        d="M256,400c-8.8,0-16,7.2-16,16v32c0,8.8,7.2,16,16,16s16-7.2,16-16v-32C272,407.2,264.8,400,256,400z"
      />
      <path
        className="sun-ray-six"
        d="M380.5,357.8c-6.3-6.2-16.4-6.2-22.6,0c-6.3,6.2-6.3,16.4,0,22.6l22.6,22.6c6.2,6.2,16.4,6.2,22.6,0
            s6.2-16.4,0-22.6L380.5,357.8z"
      />
      <path
        className="sun-ray-five"
        d="M448,240h-32c-8.8,0-16,7.2-16,16s7.2,16,16,16h32c8.8,0,16-7.2,16-16S456.8,240,448,240z"
      />
      <path
        className="sun-ray-four"
        d="M380.4,154.2l22.6-22.6c6.2-6.2,6.2-16.4,0-22.6s-16.4-6.2-22.6,0l-22.6,22.6c-6.2,6.2-6.2,16.4,0,22.6
            C364.1,160.4,374.2,160.4,380.4,154.2z"
      />
      <path
        className="sun-ray-three"
        d="M256,112c8.8,0,16-7.2,16-16V64c0-8.8-7.2-16-16-16s-16,7.2-16,16v32C240,104.8,247.2,112,256,112z"
      />
      <path
        className="sun-ray-two"
        d="M131.5,154.2c6.3,6.2,16.4,6.2,22.6,0c6.3-6.2,6.3-16.4,0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6,0
            c-6.2,6.2-6.2,16.4,0,22.6L131.5,154.2z"
      />
      <path
        className="sun-ray-one"
        d="M112,256c0-8.8-7.2-16-16-16H64c-8.8,0-16,7.2-16,16s7.2,16,16,16h32C104.8,272,112,264.8,112,256z"
      />
    </svg>
  )
}
